import { sendMail } from './send-mail';

export const MailingService = {
    sendMail,
};
